// frontend/src/components/event/HybridBadge.js
import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { parseLocation, countryCodeToFlag } from "../../utils/locationUtils";

const TYPE_LABELS = {
  webinar: { de: "Webinar", en: "Webinar" },
  workshop: { de: "Workshop", en: "Workshop" },
  meetup: { de: "Meetup", en: "Meetup" },
  course: { de: "Kurs", en: "Course" },
  conference: { de: "Konferenz", en: "Conference" },
  talk: { de: "Vortrag", en: "Talk" },
};

const HybridBadge = ({ eventType, location, size = "md" }) => {
  const { t } = useLanguage();

  const label = TYPE_LABELS[eventType] || TYPE_LABELS.webinar;
  const { city, countryCode } = parseLocation(location);
  const flag = countryCodeToFlag(countryCode);

  const sizeClasses = {
    sm: "text-xs pl-1 pr-2 py-1",
    md: "text-sm pl-1 pr-3 py-1",
    lg: "text-base pl-1.5 pr-3 py-1.5",
  };

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded font-bold bg-[#002855] text-white ${sizeClasses[size]}`}
    >
      <span className="bg-red-600 text-white px-[3px] py-0.5 rounded-sm leading-none">
        Live
      </span>
      <span className="leading-none">{t(label)}</span>
      {city && (
        <>
          <span className="border-l-2 border-white/70 self-stretch -my-px mx-0.5"></span>
          {flag && <span className="leading-none">{flag}</span>}
          <span className="leading-none">{city}</span>
        </>
      )}
    </span>
  );
};

export default HybridBadge;
